export default __webpack_public_path__ + "static/media/recycle.f88a153a.svg";